<ng-container *ngIf="!isEmpty(eAddresses)">
	<ng-container *ngFor="let address of getEAddressTypeMail(eAddresses)">
		<div><his-display-email value="{{address.eaddress}}"></his-display-email></div>
	</ng-container>
	<ng-container *ngFor="let address of getEAddressTypePhone(eAddresses)">
		<div><his-display-phone value="{{address.eaddress}} ({{address.type.defaulttext}})"></his-display-phone></div>
	</ng-container>
	<ng-container *ngFor="let address of getEAddressTypeWeb(eAddresses)">
		<div><his-display-weblink value="{{address.eaddress}}"></his-display-weblink></div>
	</ng-container>
</ng-container>
